import { getHeader } from "../fetchData";


  export function logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("access_token");
    localStorage.removeItem("expire_at");
  }
 
  export function siteLogout() {
    localStorage.removeItem("user");
    localStorage.removeItem("access_token");
    localStorage.removeItem("expire_at");
  }
 
 export function getCurrentUser() {
  const userJson = localStorage?.getItem("user");
  if (userJson) {
    if (typeof userJson === "object") {
      return  userJson;
    } else if (typeof userJson === "string") {
      return JSON.parse(userJson);
    } else {
      return null;
    }
  } else {
    return null;
  }
  }

  export function isLogged() {
    const usr = getCurrentUser();
    if (Object.keys(usr).length === 0) {
      return false;
    } else {
      return true;
    }
  }

  export  function checkSession() {
    return getHeader("checkSession");
  }

export function headerAuth() {
  const userJson: string | null = localStorage.getItem("user");
  const userToken: string | null = localStorage.getItem("access_token");
  const user =
    userJson !== undefined && userJson !== null ? JSON.parse(userJson) : {};
  const token = userToken ? userToken : "";
  user.accessToken = token;

  const unixTime: any = localStorage.getItem("expire_at");
  const datex = new Date(parseInt(unixTime) * 1000);

  if (user && user.accessToken && user.accessToken !== "") {
    return {
      Authorization: "Bearer " + user.accessToken,
    };
  } else {
    return {};
  }
};


